import { render, staticRenderFns } from "./ChooseZhubu.vue?vue&type=template&id=28e94690&scoped=true&"
import script from "./ChooseZhubu.vue?vue&type=script&lang=js&"
export * from "./ChooseZhubu.vue?vue&type=script&lang=js&"
import style0 from "./ChooseZhubu.vue?vue&type=style&index=0&id=28e94690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e94690",
  null
  
)

export default component.exports